import { LuSearch } from "@/Components/Icons/Icons";
import {
  statusOptions,
  filling,
  JobNo,
  Active,
  taskTypeOptions
} from "@/Constant/Export/Dashboard/FilterBox";
import {
  transportModeFilter,
  customsHouseFilter,
} from "@/Constant/Common/Common.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "100%",
      rows: {
        row1: [
          {
            name: "commonSearch",
            placeholder: "Search Jobs",
            component: "text-field",
            width: "70%",
            startIconName: LuSearch,
            iconColor: "gray-300",
            gap: false,
            sx:{
              mt: 0.7,
              ml:1
            },
          },
          {
            name: "dateRange",
            component: "daterangeselector",
            width: "30%",
            sx: {
              mt: 1.4,

            },
            gap: false,
            maxDateToToday: true,
          
          },

          {
            name: "Advanced Filters",
            label: "Advanced Filters",
            component: "outlinebutton",
            iconName: "LuSlidersVertical",
            width: "20%",
            action: "toggleAdvanced",
            sx: {
              mt: 1.4,
              mr:2,
              flexGrow: 1,
              backgroundColor: "var(--gray-0)",
              borderColor: "var(--brand-600)",
              whiteSpace: "nowrap", 
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "fit-content",
              maxWidth: "100%", 
              padding: "0 12px", 
              "& .MuiButton-label": {
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                width: "100%",
                overflow: "hidden",
              },
              "& .MuiButton-startIcon": {
                margin: 0, 
                flexShrink: 0, 
              },
            },
          },
        ],
        row2: [
            {
              name: "task",
              component: "dropdown",
              width: "20%",
              placeholder: "Select Task",
              endIconName: "LuChevronDown",
              startIconName: "MdTaskAlt",
              gap: false, // ✅ numeric gap works
              options: taskTypeOptions,
              sx:{mt:0.5}

            },
          {
            name: "jobNo",
            component: "text-field",
            width: "25%",
            gap: false,
            sx:{mt:0.5}
          },
        ],
        row3: [
          {
            name: "TransportMode",
            label: "Mode",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: transportModeFilter,
            placeholder: "Select Mode",

          },
          {
            name: "beType",
            label: "BE Type",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: filling,
            placeholder: "Select BE Type",

          },
          {
            name: "importerName",
            label: "Importer",
            component: "text-field",
            width: "33%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCustomers",
            placeholder: "Select Importer",

          },
          {
            name: "customHouse",
            label: "Customs House",
            component: "dropdown",
            width: "30%",
            endIconName: "LuChevronDown",
            options: customsHouseFilter.all,
            placeholder: "Select Customs House",
          },
        ],
        row4: [
          {
            name: "portOfShipment",
            label: "Port of Shipment",
            component: "text-field",
            width: "31%",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams : "general.exportTransportMode",
            endpointWithParams : "portType",
            icon: LuSearch,
            placeholder: "Select Port of Shipment",

          },
          {
            name: "status",
            label: "Status",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: statusOptions,
            placeholder: "Select Status",

          },
          {
            name: "Active",
            label: "Active",
            component: "dropdown",
            width: "15%",
            endIconName: "LuChevronDown",
            options: Active,
            placeholder: "Select Active",

          },
        ],
        row5:[
          {
          name:"line",
          component:"hr"
        },
      ],
        row6: [
          {
            name: "Close",
            component: "outlinebutton",
            label: "Close",
            action: "closeAdvanced",
            width: "10%",
            sx: {
              display: "flex",
              justifyContent: "center", // right align
              ml: "auto", // alternative way
            },
          },
          {
            name: "search",
            component: "blackbutton",
            label: "Search",
            action: "search",
          },
        ],
      },
    },
  ],
};


